import { MagicConfigMixin, isToday, isYesterday, formatDate, ImageFormat, RoutablePage, cdnService, getFeatureEnabled } from '@gig/magic-common';
import { Mixins, Prop, Emit, Component } from 'vue-property-decorator';
import { MessageStatus, MessagePriority } from '@gig/magic-sdk/dist/adapter/messages/message';
import { magic } from '@gig/magic-sdk';
import { isResponsibleGamingAlert } from '../../util/messages.js';
import { Feature } from '@gig/magic-messages';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let MessageComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.showMessageImage = false;
    this.isArchiving = false;
  }
  get isNew() {
    return this.message.status === MessageStatus.NEW;
  }
  get isRead() {
    return this.message.status === MessageStatus.READ;
  }
  get readButtonText() {
    return this.message.status === MessageStatus.READ ? this.$t("message.read-again.button") : this.$t("message.read.button");
  }
  get sentDate() {
    if (!this.message) {
      return "";
    }
    const messageSentDate = new Date(this.message.sentAt) || new Date(this.message.created);
    if (isToday(messageSentDate)) {
      return this.$t("message.today");
    }
    if (isYesterday(messageSentDate)) {
      return this.$t("message.yesterday");
    }
    return formatDate(this.message.created);
  }
  get messageSubject() {
    return this.getMessageValue("subject", this.message);
  }
  get messageBody() {
    return this.getMessageValue("body", this.message);
  }
  get messageTNC() {
    return this.getMessageValue("tnc", this.message);
  }
  get messageLink() {
    return this.getMessageValue("link", this.message);
  }
  get messageURL() {
    return this.getMessageValue("url", this.message);
  }
  get messageLink2() {
    return this.getMessageValue("link2", this.message);
  }
  get messageURL2() {
    return this.getMessageValue("url2", this.message);
  }
  get src() {
    return this.getImage(ImageFormat.WEBP);
  }
  get avifSrcset() {
    return this.getImageSrcset(ImageFormat.AVIF);
  }
  get webpSrcset() {
    return this.getImageSrcset(ImageFormat.WEBP);
  }
  get shouldShowMessageImage() {
    return this.showMessageImage && !this.summary && this.src;
  }
  getMessageValue(key, message) {
    return message ? message[key] : "";
  }
  isGamingAlert() {
    return this.message ? isResponsibleGamingAlert(this.message) : false;
  }
  created() {
    return __async(this, null, function* () {
      this.showMessageImage = yield getFeatureEnabled(Feature.DISPLAY_MESSAGE_IMAGE);
    });
  }
  mounted() {
    if (!this.message) {
      this.routeTo({
        route: RoutablePage.MESSAGES
      });
    }
    if (this.summary) {
      return;
    }
    (() => __async(this, null, function* () {
      try {
        if (!this.message || this.message.once || this.isGamingAlert() || this.message.priority === MessagePriority.POP_OPEN) {
          return;
        }
        yield magic.methods.messages.markAsRead(this.message.id);
        this.messageRead(this.message.id);
      } catch (err) {
        console.error(err);
      }
    }))();
  }
  destroyed() {
    if (this.summary) {
      return;
    }
    (() => __async(this, null, function* () {
      try {
        if (!this.message || this.message.priority === MessagePriority.POP_OPEN || this.isGamingAlert() || !this.message.once) {
          return;
        }
        yield magic.methods.messages.archive(this.message.id);
        this.messageRead(this.message.id);
      } catch (err) {
        console.error(err);
      }
    }))();
  }
  archive() {
    return __async(this, null, function* () {
      this.isArchiving = true;
      yield magic.methods.messages.archive(this.message.id);
      this.isArchiving = false;
    });
  }
  acknowledge() {
    this.messageRead(this.message.id);
    return this.message;
  }
  messageRead(id) {
    return { id, isPopOpen: false };
  }
  ctaClicked(cta) {
    return cta;
  }
  getImageSrcset(format) {
    return `${this.getImage(format)}, ${this.getImage(format, true)} 2x`;
  }
  getImage(format, retina = false) {
    if (!this.message || !this.message.image) {
      return "";
    }
    return cdnService.getOmsImageUrl(this.message.image, {
      width: this.imageWidth,
      quality: 100,
      retina,
      format
    });
  }
};
__decorateClass([
  Prop(Boolean)
], MessageComponent.prototype, "summary", 2);
__decorateClass([
  Prop(Object)
], MessageComponent.prototype, "message", 2);
__decorateClass([
  Prop(Boolean)
], MessageComponent.prototype, "hideBacklink", 2);
__decorateClass([
  Prop({ type: Number, default: 424 })
], MessageComponent.prototype, "imageWidth", 2);
__decorateClass([
  Emit("acknowledged")
], MessageComponent.prototype, "acknowledge", 1);
__decorateClass([
  Emit("message-read")
], MessageComponent.prototype, "messageRead", 1);
__decorateClass([
  Emit("ctaClicked")
], MessageComponent.prototype, "ctaClicked", 1);
MessageComponent = __decorateClass([
  Component({
    name: "message"
  })
], MessageComponent);

export default MessageComponent;
